import { render, staticRenderFns } from "./Distributes.vue?vue&type=template&id=6bf4e581"
import script from "./Distributes.vue?vue&type=script&lang=js"
export * from "./Distributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports